import makeStyles from "@mui/styles/makeStyles";
import createStyles from "@mui/styles/createStyles";
import UserService from "../../core/service/user.service";
import { useAuth } from "../../core/context/auth.context";
import TableInterface from "@homegame/common/dist/interface/table.interface";
import Checkbox from "@mui/material/Checkbox";
import ListItemText from "@mui/material/ListItemText";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import OutlinedInput from "@mui/material/OutlinedInput";
import MenuItem from "@mui/material/MenuItem";
import { useQuery } from "@tanstack/react-query";

const useStyles = makeStyles(() =>
  createStyles({
    formControl: {
      maxWidth: "40%",
      marginRight: 10,
      "& .Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: "rgba(255,255,255,.5)",
      },
    },
    select: {},
    label: {
      top: -7,
      fontSize: 13,
      "&.Mui-focused": {
        color: "rgba(255,255,255,.7)",
        textShadow: "none",
        top: 2,
        left: 3,
      },
    },
    checkbox: {
      "& .MuiSvgIcon-root": { fill: "rgba(255,255,255,.7)" },
    },
    input: {
      borderColor: "rgba(255,255,255,.5)",
      "& .MuiSelect-select": {
        padding: "4px 35px 5px 15px",
      },
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "rgba(255,255,255,.5)",
        borderRadius: 15,
      },
    },
  }),
);

export default function SelectTableComponent({
  selectedTable,
  onChange,
}: {
  onChange: (t: TableInterface[]) => void;
  selectedTable: TableInterface[];
}) {
  const classes = useStyles({});
  const userService = new UserService();
  const { user } = useAuth();

  const { data, isFetching } = useQuery({
    queryKey: [`usertables`, { userId: user!.id }],
    queryFn: () => userService.getTables(user!.id),
    initialData: undefined,
  });

  const handleChange = (event: SelectChangeEvent<TableInterface[]>) => {
    const {
      target: { value },
    } = event;
    onChange(value as TableInterface[]);
  };

  return (
    <FormControl fullWidth className={classes.formControl}>
      {!isFetching && data && (
        <>
          <InputLabel className={classes.label}>Table</InputLabel>
          <Select
            autoWidth
            multiple
            value={selectedTable}
            onChange={handleChange}
            input={<OutlinedInput label="Type" className={classes.input} />}
            renderValue={(selected) =>
              Object.values(selected)
                .map((s) => s.name)
                .join(", ")
            }
          >
            {data?.data &&
              data?.data.length > 0 &&
              data.data.map((table: TableInterface) => (
                // @ts-ignore
                <MenuItem key={table.id!} value={table}>
                  <Checkbox
                    checked={selectedTable.includes(table)}
                    className={classes.checkbox}
                  />
                  <ListItemText primary={table.name} />
                </MenuItem>
              ))}
          </Select>
        </>
      )}
    </FormControl>
  );
}
